import React, { useEffect, useState } from 'react';
import { getImage, getLogo } from '../Shared/Functions';
import { withToast } from '../Shared/Toast';
import { PrivacyFooter } from '../Shared/PrivacyFooter';
import '../../scss/app.scss';
import { CircularProgress, Grid } from '@mui/material';
import GlobalAlerts from '../Shared/GlobalAlerts';

const Login = ({children}) => {
    const [logoSrc, setLogoSrc] = useState<string>("")
    const [src, setSrc] = useState<string>("")
    let [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        getLogo().then((x:any) => {
            setLogoSrc(x)
            setLoading(false)
        })
        getImage().then((x:any) => {
            setSrc(x)
            setLoading(false)
        })
    }, [])

    return(loading ?
        <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
        <>
            <a href="#login-main-content" className="sr-only sr-only-focusable">Skip to main content</a>
            <GlobalAlerts />
            <Grid container className='login-image' style={{ backgroundImage: `url(${src})` }}>
                <div className='login-info-container'>
                    <Grid item className='login-info-panel'>
                        <div>
                            <img src={logoSrc} alt="" style={{ maxWidth: "200px", height: "auto", paddingTop: "20px" }} />
                            <main id="login-main-content">
                                {children}
                            </main>
                        </div>
                        <div>
                            <PrivacyFooter />
                        </div>
                    </Grid>
                </div>
            </Grid>
        </>
    )
}

export default withToast(Login);
